app.directive('regulationClientClassements', [
    '$rootScope', '$timeout', 'ClassementClientApiService', 'utilsService', 'semanticUIService',
    function ($rootScope, $timeout, ClassementClientApiService, utilsService, semanticUIService) {
        return {
            restrict: 'AE',
            scope: {
                onChange: '=',
                onLoaded: '=',
                selectedClassements: '=',
                selectedSousClassements: '='
            },
            templateUrl: '/templates/partials/directives/regulation-classements.html',
            link: function (scope) {
                scope.loading = true;
                scope.classements = [];
                scope.checked_classements = {};
                scope.checked_sous_classements = {};
                scope.checkboxes = null;
                scope.all_sous_classements_count = null;

                scope.addElement = function (id, label) {
                    if (!utilsService.isSet(id) || isNaN(id) || utilsService.isSet(scope.checked[id])) {
                        return;
                    }
                    scope.checked[id] = label;
                };
                scope.removeElement = function (id) {
                    if (!utilsService.isSet(id) || isNaN(id) || !utilsService.isSet(scope.checked[id])) {
                        return;
                    }
                    delete scope.checked[id];
                };

                scope.onCheckToggle = function () {
                    if (scope.all_sous_classements_count !== null) {
                        scope.all_sous_classements_count -= 1;

                        if (scope.all_sous_classements_count !== 0) {
                            return;
                        }
                        scope.all_sous_classements_count = null;
                    }
                    $timeout(function () {
                        scope.onChange({
                            sous_classements: scope.checked_sous_classements,
                            classements: scope.checked_classements
                        });
                    });
                };

                scope.onChecked = function () {
                    var $el = $(this);

                    if ($el.attr('name') === 'select_all_sous_classements') {
                        var classement_id = $el.data('classement-id');
                        var $checkbox = scope.checkboxes.find('[name="sous_classements[]"][data-classement-id="' + classement_id + '"]:not(:checked)');
                        if (!$checkbox || !$checkbox.length) {
                            return;
                        }
                        scope.all_sous_classements_count = $checkbox.length;
                        $checkbox.parent('.ui.checkbox').checkbox('check');
                        return;
                    }

                    var value = parseInt($el.val(), 10);
                    var label = $el.data('label');

                    if ($el.attr('name') === 'classement') {
                        scope.checked_classements[value] = label;
                    } else {
                        scope.checked_sous_classements[value] = label;
                    }

                    scope.onCheckToggle();
                };

                scope.onUnchecked = function () {
                    var $el = $(this);

                    if ($el.attr('name') === 'select_all_sous_classements') {
                        var classement_id = $el.data('classement-id');
                        var $checkbox = scope.checkboxes.find('[name="sous_classements[]"][data-classement-id="' + classement_id + '"]:checked');
                        if (!$checkbox || !$checkbox.length) {
                            return;
                        }
                        scope.all_sous_classements_count = $checkbox.length;
                        $checkbox.parent('.ui.checkbox').checkbox('uncheck');
                        return;
                    }

                    var value = parseInt($el.val(), 10);

                    if ($el.attr('name') === 'classement') {
                        delete scope.checked_classements[value];
                    } else {
                        delete scope.checked_sous_classements[value];
                    }

                    scope.onCheckToggle();
                };

                // Classements
                scope.setSelectedClassements = function (id) {
                    var $checkbox = scope.checkboxes.find('[name="classement"][value="' + id + '"]');
                    if (!$checkbox || !$checkbox.length) {
                        return;
                    }
                    $checkbox.parent('.ui.checkbox').checkbox('check');
                };

                $rootScope.$on('regulations.client.classement.add', function (e, data) {
                    scope.setSelectedClassements(data.id);
                });

                $rootScope.$on('regulations.client.classement.remove', function (e, data) {
                    var $checkbox = scope.checkboxes.find('[name="classement"][value="' + data.id + '"]');
                    if (!$checkbox || !$checkbox.length) {
                        return;
                    }
                    $checkbox.parent('.ui.checkbox.checked').checkbox('uncheck');
                });

                // Sous-classements
                scope.setSelectedSousClassements = function (id) {
                    var $checkbox = scope.checkboxes.find('[name="sous_classements[]"][value="' + id + '"]');
                    if (!$checkbox || !$checkbox.length) {
                        return;
                    }
                    $checkbox.parent('.ui.checkbox').checkbox('check');
                };

                $rootScope.$on('regulations.client.sous_classement.add', function (e, data) {
                    scope.setSelectedSousClassements(data.id);
                });

                $rootScope.$on('regulations.client.sous_classement.remove', function (e, data) {
                    var $checkbox = scope.checkboxes.find('[name="sous_classements[]"][value="' + data.id + '"]');
                    if (!$checkbox || !$checkbox.length) {
                        return;
                    }
                    $checkbox.parent('.ui.checkbox.checked').checkbox('uncheck');
                });

                $rootScope.$on('regulations.client.classements.reset', function () {
                    scope.checked_classements = {};
                    scope.checked_sous_classements = {};
                    scope.checkboxes.checkbox('set unchecked');
                });

                scope.onResponse = function (response) {
                    if (response) {
                        let tempClassements = [];
                        response.forEach(function (item) {
                            let classement = {
                                id: parseInt(item['id']),
                                name: item['nom']
                            };

                            if(angular.isDefined(item['_children'])) {
                                let tempSousClassements = [];
                                item['_children'].forEach(function (subItem) {
                                    let ssClassement = {
                                        id: parseInt(subItem['id']),
                                        name: subItem['nom'],
                                        classement_id: classement['id']
                                    };
                                    tempSousClassements.push(ssClassement);
                                });
                                classement['sous_classements'] = tempSousClassements;
                            }

                            tempClassements.push(classement);
                        });

                        scope.classements = tempClassements;
                        $timeout(function () {
                            scope.checkboxes = semanticUIService.load("checkbox", ".ui.checkbox", {
                                onChecked: scope.onChecked,
                                onUnchecked: scope.onUnchecked
                            });

                            semanticUIService.load("accordion", ".regulation__classements_accordion", {
                                selector: {trigger: '.trigger__icon'},
                                exclusive: false,
                                onOpening: function () {
                                    var $el = $(this).prev('.title').find('.trigger__icon > .icon');
                                    $el.removeClass('right');
                                    $el.addClass('down');
                                },
                                onClosing: function () {
                                    var $el = $(this).prev('.title').find('.trigger__icon > .icon');
                                    $el.removeClass('down');
                                    $el.addClass('right');
                                }
                            });

                            if (scope.selectedClassements && scope.selectedClassements.length) {
                                scope.selectedClassements.split(',').forEach(scope.setSelectedClassements);
                            }

                            if (scope.selectedSousClassements && scope.selectedSousClassements.length) {
                                scope.selectedSousClassements.split(',').forEach(scope.setSelectedSousClassements);
                            }

                            scope.onLoaded(scope.classements);
                        });
                    }

                    scope.loading = false;
                };

                ClassementClientApiService.getClassements().then(scope.onResponse);
            }
        }
    }]);
